import $ from 'jquery';

const editors = {};

function cloneEditor(template) {
  const editor = document
    .importNode(template.content, true).firstElementChild;
  editor.classList.add('grid-cell-editor');
  return editor;
}

export default class CellEditorLoader {
  constructor({ key, url, onLoad }) {
    this.key = key;
    this.url = url;
    this.onLoad = onLoad;
  }

  static create({ key, url, onLoad }) {
    if (!editors[key]) {
      editors[key] = {
        loader: new CellEditorLoader({ key, url, onLoad }),
      };
    }

    return editors[key].loader;
  }

  get editor() {
    return new Promise((resolve) => {
      const editor = editors[this.key];
      if (editor.request) {
        editor.request.then(() => resolve(cloneEditor(editor.template)));
      } else {
        resolve(cloneEditor(editor.template));
      }
    });
  }

  clear() {
    const editor = editors[this.key];
    Object.assign(editor, {
      request: null,
      template: null,
    });
  }

  load() {
    const editor = editors[this.key];
    if (editor.request || editor.template) return;

    editor.request = $.ajax({
      url: this.url,
      method: 'get',
      dataType: 'html',
    }).then((html) => {
      const template = document.createElement('template');
      template.innerHTML = html;

      Object.assign(editor, {
        request: null,
        template,
      });

      if (this.onLoad) this.onLoad();
    });
  }
}
